// Maps each question to the option currently selected by the student, used as the starting point for editing.
export function getSelectedAnswers(answerKey) {
  return answerKey.reduce((answers, question) => {
    if (question.optionSelected?.optionId) {
      answers[question.questionId] = question.optionSelected.optionId;
    }
    return answers;
  }, {});
}

export function toTestResponse(givenAnswers) {
  return Object.keys(givenAnswers).map((questionId) => ({
    questionId, optionId: givenAnswers[questionId],
  }));
}

export function areAllQuestionsAnswered(answerKey, givenAnswers) {
  return answerKey.length > 0
    && answerKey.every((question) => givenAnswers[question.questionId] != null);
}
